import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush
    .call(this, location)
    .catch(error => {
      if (error.name === 'NavigationDuplicated') return
      throw error
    })
}

Vue.use(VueRouter)

const listRoutes = [
  {
    path: 'dados-pessoais',
    name: 'personal-data',
    component: () => import('../components/organisms/PersonalData/index.vue'),
    meta: {
      nav: true,
      stepName: 'Dados Pessoais'
    }
  },
  {
    path: 'endereco',
    name: 'address',
    component: () => import('../components/organisms/Address.vue'),
    meta: {
      nav: true,
      stepName: 'Endereco'
    }
  }
]

const _routerPayment = {
  path: 'pagamento',
  name: 'payment',
  component: () => import('../components/organisms/Payment.vue'),
  meta: {
    nav: true,
    stepName: 'Pagamento'
  }
}

const _routerSendQuotation = {
  path: 'envio',
  name: 'sendQuotation',
  component: () => import('../components/organisms/SendQuotation.vue'),
  meta: {
    nav: true,
    stepName: 'Envio'
  }
}

const _routerTermsAndConditions = {
  path: 'termos-e-condicoes',
  name: 'termsAndConditions',
  component: () => import('../components/organisms/TermsAndConditions.vue'),
  meta: {
    nav: true,
    stepName: 'termos e condições'
  }
}

if (process.env.VUE_APP_JOURNEY_NAME === 'operador') {
  listRoutes.push(_routerSendQuotation)
} else if (process.env.VUE_APP_JOURNEY_NAME === 'funcionario') {
  listRoutes.push(_routerTermsAndConditions)
} else {
  listRoutes.push(_routerPayment)
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'checkout',
      redirect: listRoutes[0].path,
      component: () => import('../views/Checkout.vue'),
      children: listRoutes
    },
    {
      path: '/sucesso',
      name: 'success',
      component: () => import('../views/Success/index.vue'),
      meta: {
        nav: true,
        stepName: 'Sucesso'
      }
    },
    {
      path: '/confirmacao',
      name: 'confirmed',
      component: () => import('../views/Confirmed.vue'),
      meta: {
        nav: true,
        stepName: 'Confirmacao'
      }
    },
    {
      path: '*',
      redirect: listRoutes[0].path
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.isConfigApp) {
    await store.dispatch('initApp')
  }

  // Atualiza o valor do step
  store.state.steps.currentStep = to.meta.stepName

  if (to.name === 'payment') {
    window.dataLayer.push({
      event: 'afiliattionTag',
      level: 'basketPage'
    })
  }

  next()
})

router.afterEach((to, from) => {
  store.dispatch('lead/patchLeadAction')
})

export default router
